import React, { createContext, useContext, useState } from "react";

const ModuleContext = createContext();
export const useModule = () => useContext(ModuleContext);

export const ModuleProvider = ({ children }) => {
  const [activeModuleId, setActiveModuleId] = useState(null);

  return (
    <ModuleContext.Provider value={{ activeModuleId, setActiveModuleId }}>
      {children}
    </ModuleContext.Provider>
  );
};
